import React, { useState, useMemo } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { useAmzDspContext } from 'src/contexts/AmzDspContext';
import CheckBox from 'src/components/Form/checkbox';
import Dragicon from 'src/assets/images/common/drag.svg';
import DownArrow from 'src/assets/images/common/collapse-down.svg';
import RightArrow from 'src/assets/images/common/collapse-right.svg';
import IconButton from '@mui/material/IconButton';

export default function customTablesDrag({ isDspTableList = false, tablesList, updateTablesList, setCustomTableAlert }) {
  const { amzDspState } = useAmzDspContext();
  const [groupTitle, setGroupTitle] = useState('');

  console.log('checktablesList', tablesList);

  const hierarchicalTablesList = useMemo(() => {
    return tablesList.map(group => {
      const tablesWithCustom = [];
      const regularTables = group.table.filter(table => !table.custom);
      const customTables = group.table.filter(table => table.custom === 1);

      regularTables.forEach(table => {
        tablesWithCustom.push({ ...table, isParent: true });
        
        const relatedCustomTables = customTables.filter(customTable => {
          const customReportType = customTable.custom_table_report;
          const parentReports = table.reports || [];
          return parentReports.includes(customReportType);
        });

        relatedCustomTables.forEach(customTable => {
          tablesWithCustom.push({ ...customTable, isCustomChild: true, parentTableId: table.table_id });
        });
      });

      const orphanedCustomTables = customTables.filter(customTable => {
        const customReportType = customTable.custom_table_report;
        return !regularTables.some(table => (table.reports || []).includes(customReportType));
      });
      
      tablesWithCustom.push(...orphanedCustomTables.map(t => ({ ...t, isCustomChild: false })));

      return {
        ...group,
        table: tablesWithCustom
      };
    });
  }, [tablesList]);

  const onDragEnd = (result) => {
    console.log('onDragEnd', result);
    const { source, destination, type } = result;

    if (!destination || !source) {
      return;
    }

    const draggedIndex = source.index;
    const newIndex = destination.index;

    console.log({ draggedIndex, newIndex, type });

    if (type === 'GROUP') {
      const newGroups = Array.from(tablesList);
      const [removed] = newGroups.splice(result.source.index, 1);
      newGroups.splice(result.destination.index, 0, removed);
      updateTablesList([...newGroups]);
    } else if (type.startsWith('CUSTOM_')) {
      const parentTableId = type.replace('CUSTOM_', '');
      const newGroups = [...tablesList];
      const groupIndex = parseInt(source.droppableId.split('-')[2]);
      const group = newGroups[groupIndex];

      const customTables = group.table.filter(
        t => t.custom === 1 && t.custom_table_report === group.table.find(p => p.table_id === parentTableId)?.reports?.[0]
      );
      
      const allTables = [...group.table];
      const parentIndex = allTables.findIndex(t => t.table_id === parentTableId);
      
      const withoutCustom = allTables.filter(
        t => !(t.custom === 1 && t.custom_table_report === group.table.find(p => p.table_id === parentTableId)?.reports?.[0])
      );
      
      const [removed] = customTables.splice(draggedIndex, 1);
      customTables.splice(newIndex, 0, removed);
      
      withoutCustom.splice(parentIndex + 1, 0, ...customTables);
      
      group.table = withoutCustom;
      updateTablesList([...newGroups]);
    } else {
      const newGroups = [...tablesList];
      const groupIndex = parseInt(source.droppableId.split('-')[1]);
      const group = newGroups[groupIndex];

      const hierarchicalGroup = hierarchicalTablesList[groupIndex];
      const mainTables = hierarchicalGroup.table.filter(t => !t.isCustomChild);
      
      const draggedTable = mainTables[draggedIndex];
      const targetTable = mainTables[newIndex];
      
      const draggedCustomChildren = hierarchicalGroup.table.filter(
        t => t.isCustomChild && t.parentTableId === draggedTable.table_id
      );
      
      const flatDraggedIndex = group.table.findIndex(t => t.table_id === draggedTable.table_id);
      const flatTargetIndex = group.table.findIndex(t => t.table_id === targetTable.table_id);
      
      const itemsToMove = [draggedTable, ...draggedCustomChildren];
      const remainingTables = group.table.filter(
        t => t.table_id !== draggedTable.table_id && 
             !draggedCustomChildren.some(ct => ct.table_id === t.table_id)
      );
      
      const insertIndex = flatDraggedIndex < flatTargetIndex 
        ? remainingTables.findIndex(t => t.table_id === targetTable.table_id) + 1
        : remainingTables.findIndex(t => t.table_id === targetTable.table_id);
      
      remainingTables.splice(insertIndex, 0, ...itemsToMove);
      
      group.table = remainingTables;
      updateTablesList([...newGroups]);
    }
  };

  const onGroupUpdate = (event, eventOf, groupInfo, tableInfo) => {
    const {
      target: { checked }
    } = event;

    console.log('event', checked);

    if (eventOf == 'group') {
      updateTablesList(
        [...tablesList.map((item) => {
          if (item.group_name === groupInfo.group_name) {
            return {
              ...item,
              show: checked ? 'yes' : 'no',
              table: item.table?.map((table_item) => {
                return {
                  ...table_item,
                  show: checked ? 'yes' : 'no'
                };
              })
            };
          }
          return { ...item };
        })]
      );
    } else if (eventOf == 'table') {
      updateTablesList(
        [...tablesList.map((group_item) => {
          if (group_item.group_name === groupInfo.group_name) {
            return {
              ...group_item,
              table: group_item.table?.map((table_item) => {
                if (table_item?.table_id === tableInfo?.table_id) {
                  return {
                    ...table_item,
                    show: checked ? 'yes' : 'no'
                  };
                }
                return {
                  ...table_item
                };
              })
            };
          }
          return { ...group_item };
        })]
      );
    }
  };

  const renderCustomTables = (customTables, groupIndex, parentTable) => {
    if (!customTables || customTables.length === 0) return null;

    const selectedCustomTablesCount = customTables.filter(ct => ct.show === 'yes').length;

    return (
      <Droppable 
        droppableId={`custom-group-${groupIndex}-${parentTable.table_id}`} 
        type={`CUSTOM_${parentTable.table_id}`}
      >
        {(provided, snapshot) => (
          <div 
            ref={provided.innerRef} 
            {...provided.droppableProps}
            className={`custom-tables-container ${snapshot.isDraggingOver ? 'drag-drop-box' : ''}`}
          >
            {customTables.map((customTable, customIndex) => (
              <Draggable
                key={`drag-${customTable.table_id}`}
                draggableId={`custom-${customTable.table_id}`}
                index={customIndex}
                type={`CUSTOM_${parentTable.table_id}`}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className={`d-flex align-items-center justify-content-between py-1 ${snapshot.isDragging ? 'dragging-item' : ''}`}
                    style={{ 
                      ...provided.draggableProps.style,
                      paddingLeft: '22px',
                      borderLeft: '1px solid #e0e0e0',
                      marginLeft: '7px'
                    }}
                  >
                    <CheckBox
                      id={`${String(customTable.table_id).replace(/[^a-zA-Z0-9]/g, '_')}_${customIndex}_${String(parentTable.table_name).replace(/[^a-zA-Z0-9]/g, '_')}`}
                      label={customTable.table_name}
                      classes="text-capitalize label_wrap f-10"
                      checked={customTable?.show === 'yes'}
                      style={{ padding: '5px' }}
                      action={(event) => {
                        const { target: { checked } } = event;
                        
                        // Check if trying to select more than 2 custom tables
                        if (checked && selectedCustomTablesCount >= 2) {
                          event.preventDefault();
                          setCustomTableAlert(true);
                          // Auto-hide alert after 3 seconds
                          setTimeout(() => {
                            setCustomTableAlert(false);
                          }, 3000);
                          return;
                        }
                        
                        onGroupUpdate(event, 'table', hierarchicalTablesList[groupIndex], customTable);
                      }}
                    />
                    <div {...provided.dragHandleProps} style={{ cursor: 'grab' }}>
                      <img style={{ float: 'right', margin: '0px' }} src={Dragicon} alt="draggable" className="wid-8" />
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  };

  const renderTableWithCustom = (table, groupIndex, tableIndex, groupInfo) => {
    const customChildTables = hierarchicalTablesList[groupIndex].table.filter(
      t => t.isCustomChild && t.parentTableId === table.table_id
    );

    return (
      <React.Fragment key={`table-${table.table_id}`}>
        <Draggable
          key={`drag-${table.table_id}`}
          draggableId={`table-${table.table_id}`}
          index={tableIndex}
          type="TABLE"
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              className={`d-flex align-items-center justify-content-between py-1 ${snapshot.isDragging ? 'dragging-item' : ''}`}
            >
              <CheckBox
                id={`${String(table.table_id).replace(/[^a-zA-Z0-9]/g, '_')}_${tableIndex}_${String(groupInfo.group_name).replace(/[^a-zA-Z0-9]/g, '_')}`}
                label={table.table_name?.replace(/_/g, ' ')}
                classes="text-capitalize label_wrap f-10"
                checked={table?.show === 'yes'}
                style={{ padding: '5px' }}
                action={(event) => {
                  onGroupUpdate(event, 'table', groupInfo, table);
                }}
              />
              <div {...provided.dragHandleProps} style={{ cursor: 'grab' }}>
                <img style={{ float: 'right', margin: '0px' }} src={Dragicon} alt="draggable" className="wid-8" />
              </div>
            </div>
          )}
        </Draggable>
        {customChildTables.length > 0 && renderCustomTables(customChildTables, groupIndex, table)}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable key={`drop-master-group`} droppableId={`master-group`} type="GROUP">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className={`${snapshot.isDraggingOver ? 'drag-drop-box' : ''}`}>
              {hierarchicalTablesList.map((group, groupIndex) => {
                const mainTables = group.table.filter(t => !t.isCustomChild);
                
                return (
                  <Draggable
                    key={`drag-${group.group_id}`}
                    draggableId={group.group_id}
                    index={groupIndex}
                    type="GROUP"
                    isDragDisabled={groupTitle !== ''}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`${snapshot.isDragging ? 'dragging-item' : ''}`}
                      >
                        <div className="d-flex flex-column w-100">
                          {/* Group Header */}
                          <div className="d-flex align-items-center gap-4 f-15 f-w-400 cursor-pointer text-dark py-1">
                            <img style={{ float: 'right', margin: '0px' }} src={Dragicon} alt="draggable" className="wid-8" />
                            <IconButton
                              size="small"
                              aria-label="collapseTableRow"
                              disabled={!(isDspTableList && amzDspState?.reportTableTab === (group?.table?.length > 0 ? group?.table[0]?.tabId : 0) || !isDspTableList)}
                              onClick={(e) => {
                                e.preventDefault();
                                if(isDspTableList && amzDspState?.reportTableTab === (group?.table?.length > 0 ? group?.table[0]?.tabId : 0) || !isDspTableList) {
                                  if (groupTitle === group.group_name) {
                                    setGroupTitle('');
                                  } else {
                                    setGroupTitle(group.group_name);
                                  }
                                }
                              }}
                            >
                              <img src={groupTitle === group.group_name ? DownArrow : RightArrow} alt="table-collapse" />
                            </IconButton>
                            <h4 
                              className="f-13 f-w-400" 
                              onClick={(e) => {
                                e.preventDefault();
                                if (groupTitle === group.group_name) {
                                  setGroupTitle('');
                                } else {
                                  setGroupTitle(group.group_name);
                                }
                              }}
                            >
                              {group?.group_title}
                            </h4>
                          </div>
                          
                          {(groupTitle === group.group_name) && (
                            <div className="pl-35">
                              <Droppable droppableId={`group-${groupIndex}`} direction="vertical" type="TABLE">
                                {(provided, snapshot) => (
                                  <div 
                                    ref={provided.innerRef} 
                                    {...provided.droppableProps}
                                    className={`${snapshot.isDraggingOver ? 'drag-drop-box' : ''}`}
                                  >
                                    {/* <div className="d-flex align-items-center justify-content-between py-1">
                                      <CheckBox
                                        id={`select-all-${group.group_id}`}
                                        label="All"
                                        classes={`text-capitalize label_wrap f-10 ${
                                          !group.table?.every((item) => item.show == 'yes') && 
                                          group.table?.some((item) => item.show == 'yes') 
                                            ? 'indet_check' 
                                            : ''
                                        }`}
                                        checked={group.table?.some((item) => item.show == 'yes')}
                                        style={{ padding: '5px' }}
                                        action={(event) => {
                                          onGroupUpdate(event, 'group', group, {});
                                        }}
                                      />
                                      <img style={{ float: 'right', margin: '0px' }} src={Dragicon} alt="draggable" className="wid-8" />
                                    </div> */}
                                    
                                    {mainTables.map((table, tableIndex) => 
                                      renderTableWithCustom(table, groupIndex, tableIndex, group)
                                    )}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </React.Fragment>
  );
}
